import React, { useState } from "react";
import { useAuth } from "../../utils/useAuth";
import { LoginForm, LoginFormValues } from "./LoginForm";
import * as Yup from "yup";
import { UserTransport } from "../../transports/user";

export const LoginPage: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const { saveAuth, setCurrentUser } = useAuth();

    const submitHandler = async (values: LoginFormValues) => {
        setLoading(true);
        try {
            saveAuth(await UserTransport.login(values.email, values.password));
            setCurrentUser(await UserTransport.getUser());
        } catch (e) {
            saveAuth(undefined);
            setLoading(false);
            throw e;
        }
    };

    const loginSchema = Yup.object().shape({
        email: Yup.string()
            .email("Wrong email format")
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required("Email is required"),
        password: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required("Password is required"),
    });

    return (
        <LoginForm loading={loading} validationSchema={loginSchema} handleSubmit={submitHandler} />
    );
};
